import { render, staticRenderFns } from "./PartnerDashboard.vue?vue&type=template&id=4681934d&scoped=true"
import script from "./PartnerDashboard.vue?vue&type=script&lang=js"
export * from "./PartnerDashboard.vue?vue&type=script&lang=js"
import style0 from "./PartnerDashboard.vue?vue&type=style&index=0&id=4681934d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681934d",
  null
  
)

export default component.exports